(function () {
  var root = document.querySelector("[data-spd-calc]");
  if (!root) return;

  var C0 = (n) =>
    new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: "GBP",
      maximumFractionDigits: 0,
    }).format(n);
  var C2 = (n) =>
    new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: "GBP",
      maximumFractionDigits: 2,
    }).format(n);
  var q = (s) => root.querySelector(s);

  var PRICE = parseFloat(root.getAttribute("data-unit-price")) || 2999;
  var members = 2,
    years = 3,
    mode = "pt",
    travel = "public",
    timeOn = true;

  var O = {
    hero: q('[data-out="hero"]'),
    mon: q('[data-out="month"]'),
    brk: q('[data-out="break"]'),
    per: q('[data-out="per"]'),
    tSpd: q('[data-out="t-spd"]'),
    tGym: q('[data-out="t-gym"]'),
    tSav: q('[data-out="t-save"]'),
    p1: q('[data-out="p1"]'),
    p2: q('[data-out="p2"]'),
    p3: q('[data-out="p3"]'),
    barS: q('[data-out="bar-s"]'),
    barG: q('[data-out="bar-g"]'),
    vS: q('[data-out="v-s"]'),
    vG: q('[data-out="v-g"]'),
    modeLbl: q('[data-out="mode-lbl"]'),
    barLbl: q('[data-out="bar-lbl"]'),
    breakdown: q('[data-out="breakdown"]'),
  };

  var I = {
    people: q('[data-role="people"]'),
    mode: q('[data-role="mode"]'),
    years: q('[data-role="years"]'),
    travel: q('[data-role="travel"]'),
    time: q('[data-role="time"]'),

    gym: q('input[name="gym"]'),
    pt: q('input[name="pt"]'),
    ptw: q('select[name="ptw"]'),

    fare: q('input[name="fare"]'),
    trips: q('input[name="trips"]'),

    miles: q('input[name="miles"]'),
    carTrips: q('input[name="carTrips"]'),
    ppm: q('input[name="ppm"]'),

    mins: q('input[name="mins"]'),
    vhr: q('input[name="vhr"]'),

    child: q('input[name="child"]'),
  };

  function setOn(container, btn) {
    container
      .querySelectorAll(".chip")
      .forEach((x) => x.classList.remove("is-on"));
    btn.classList.add("is-on");
  }

  function showScope(kind) {
    var pub = root.querySelectorAll('[data-scope="public"]');
    var car = root.querySelectorAll('[data-scope="car"]');
    const trips = root.querySelector("div:has(> label[for='trips'])");
    const carTrips = root.querySelector("div:has(> label[for='carTrips'])");

    if (pub && car) {
      if (kind === "public") {
        if (pub.length > 0) {
          pub.forEach((p) => (p.style.display = "grid"));
        }

        if (car.length > 0) {
          car.forEach((c) => (c.style.display = "none"));
        }
      } else {
        if (pub.length > 0) {
          pub.forEach((p) => (p.style.display = "none"));
        }

        if (car.length > 0) {
          car.forEach((c) => (c.style.display = "grid"));
        }
      }
    }

    if (trips && carTrips) {
      if (kind === "public") {
        trips.style.display = "block";
        carTrips.style.display = "none";
      } else {
        trips.style.display = "none";
        carTrips.style.display = "block";
      }
    }
  }

  function compute() {
    var gymFee = +I.gym.value || 0;
    var ptRate = +I.pt.value || 0;
    var ptPerW = +I.ptw.value || 0;
    if (mode === "gym") ptPerW = 0;

    var membershipAnnual = gymFee * 12 * members;
    var ptAnnual = ptRate * ptPerW * 52 * members;

    var travelAnnual = 0,
      travelDesc = "";
    if (travel === "public") {
      var fare = +I.fare.value || 0;
      var trips = +I.trips.value || 0;
      travelAnnual = fare * trips * 52 * members;
      travelDesc = "Public transport: " + C2(fare) + "/trip × " + trips + "/wk";
    } else {
      var miles = +I.miles.value || 0;
      var times = +I.carTrips.value || 0;
      var ppm = +I.ppm.value || 0;
      travelAnnual = miles * ppm * times * 52 * members;
      travelDesc =
        "Car: " + miles + " mi/rt × " + C2(ppm) + "/mi × " + times + "/wk";
    }

    var timeAnnual = 0,
      timeDesc = "";
    if (timeOn) {
      var mins = +I.mins.value || 0;
      var vhr = +I.vhr.value || 0;
      var tripsWk =
        travel === "public" ? +I.trips.value || 0 : +I.carTrips.value || 0;
      timeAnnual = (mins / 60) * vhr * tripsWk * 52 * members;
      timeDesc = "Time: " + mins + " min/rt × " + C2(vhr) + "/hr";
    }

    var childAnnual = I.child.checked ? 1.5 * 10 * 52 : 0;
    var childDesc = I.child.checked ? "Childcare: £10/hr × 1.5hr/wk" : null;

    // Defensive ceiling: bound modelled gym/PT/travel/time spend to a realistic
    // per-person annual figure so deliberate max-everything inputs can't headline an absurd saving.
    var PERSON_ANNUAL_CAP = 12000;
    var capNote = "";
    var nonChild = membershipAnnual + ptAnnual + travelAnnual + timeAnnual;
    var personCap = PERSON_ANNUAL_CAP * members;
    if (nonChild > personCap) {
      var scale = personCap / nonChild;
      membershipAnnual *= scale;
      ptAnnual *= scale;
      travelAnnual *= scale;
      timeAnnual *= scale;
      nonChild = personCap;
      capNote = "Modelled spend capped at " + C0(PERSON_ANNUAL_CAP) + "/person/yr";
    }
    var gymAnnual = nonChild + childAnnual;
    var gymTotal = gymAnnual * years;
    var spdTotal = PRICE;

    var save = Math.max(0, gymTotal - spdTotal);
    var savePm = save / (years * 12);
    var perPersonPm = PRICE / (years * 12) / members;
    var brkMonths = gymAnnual > 0 ? Math.ceil(PRICE / (gymAnnual / 12)) : 0;

    O.hero.textContent =
      "Save " + C0(save) + " over " + years + " year" + (years > 1 ? "s" : "");
    O.mon.textContent = C2(savePm) + " per month back";
    O.brk.textContent = "Break even: " + (brkMonths || "—") + " months";
    O.per.textContent =
      "Speediance ≈ " + C2(perPersonPm) + " per person monthly";

    var max = Math.max(spdTotal, gymTotal);
    O.barS.style.width = Math.max(8, Math.round((spdTotal / max) * 100)) + "%";
    O.barG.style.width = Math.max(8, Math.round((gymTotal / max) * 100)) + "%";
    O.vS.textContent = C0(spdTotal);
    O.vG.textContent = C0(gymTotal);

    O.tSpd.textContent = C0(spdTotal);
    O.tGym.textContent = C0(gymTotal);
    O.tSav.textContent = C0(save);

    var ptxt = years === 1 ? "1 year" : years + " years";
    O.p1.textContent = ptxt;
    O.p2.textContent = ptxt;
    O.p3.textContent = ptxt;
    O.modeLbl.textContent = mode === "pt" ? "Gym + PT" : "Gym only";
    O.barLbl.textContent = mode === "pt" ? "Gym + PT" : "Gym only";

    var parts = [
      "Gym membership: " + C0(membershipAnnual) + "/yr (" + members + "×)",
      mode === "pt" && ptPerW > 0 ? "PT: " + C0(ptAnnual) + "/yr" : null,
      travelDesc ? travelDesc + " → " + C0(travelAnnual) + "/yr" : null,
      timeDesc && timeOn ? timeDesc + " → " + C0(timeAnnual) + "/yr" : null,
      childDesc ? childDesc + " → " + C0(childAnnual) + "/yr" : null,
      capNote ? capNote : null,
    ]
      .filter(Boolean)
      .join("  •  ");
    O.breakdown.textContent = parts;
  }

  function chipGroup(container, setter) {
    if (!container) return;
    container.addEventListener("click", function (e) {
      var b = e.target.closest(".chip");
      if (!b) return;
      e.preventDefault();
      setOn(container, b);
      setter(b);
    });
  }

  chipGroup(I.people, (b) => {
    members = +b.dataset.m;
    compute();
  });
  chipGroup(I.mode, (b) => {
    mode = b.dataset.mode;
    compute();
  });
  chipGroup(I.years, (b) => {
    years = +b.dataset.y;
    compute();
  });
  chipGroup(I.travel, (b) => {
    travel = b.dataset.travel;
    showScope(travel);
    compute();
  });
  chipGroup(I.time, (b) => {
    timeOn = b.dataset.time === "on";
    compute();
  });

  [
    "gym",
    "pt",
    "ptw",
    "fare",
    "trips",
    "miles",
    "carTrips",
    "ppm",
    "mins",
    "vhr",
    "child",
  ].forEach(function (name) {
    var el = root.querySelector('[name="' + name + '"]');
    if (!el) return;
    el.addEventListener("input", compute);
    el.addEventListener("change", compute);
  });

  showScope(travel);
  compute();

  if (!customElements.get("speediance-calculator")) {
    class SpeedianceCalculator extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          stepBtn: null,
          stepCards: null,
          numberInputs: null, // To store all number inputs
        };
        this.currentStep = 1; // Steps are 1-based (e.g., Step 1, 2, 3)

        // Texts and classes for the button states
        this.btnTexts = {
          next: "Next",
          check: "Check Result",
          init: "Start Over",
        };
        this.btnClasses = {
          next: "button--gradient",
          init: "button--secondary",
        };

        // Bind 'this' for the event handler once
        this._handleStepChange = this._handleStepChange.bind(this);
        this._handleNumberInput = this._handleNumberInput.bind(this);
      }

      connectedCallback() {
        this.setupElements();
        this.addEventListeners();
      }

      disconnectedCallback() {
        this.removeEventListeners();
      }

      setupElements() {
        this.elements.stepBtn = this.querySelector(
          '[data-component="step-btn"]',
        );
        this.elements.stepCards = this.querySelectorAll(
          '[data-component="step"]',
        );

        this.elements.numberInputs = this.querySelectorAll(
          'input\[type="number"]',
        );

        if (!this.elements.stepBtn || this.elements.stepCards.length === 0) {
          console.error(
            "Calculator component is missing required elements (step button or step cards).",
          );
        }
      }

      addEventListeners() {
        if (this.elements.stepBtn) {
          this.elements.stepBtn.addEventListener(
            "click",
            this._handleStepChange,
          );
        }

        this.elements.numberInputs.forEach((input) => {
          input.addEventListener("input", this._handleNumberInput);
        });
      }

      removeEventListeners() {
        if (this.elements.stepBtn) {
          this.elements.stepBtn.removeEventListener(
            "click",
            this._handleStepChange,
          );
        }
      }

      /**
       *  Enforces the 'max' attribute on number inputs.
       * Prevents the user from manually typing a value greater than the max.
       */
      _handleNumberInput(event) {
        const input = event.target;
        const maxAttr = input.getAttribute("max");

        // Only proceed if a 'max' attribute exists.
        if (maxAttr === null || maxAttr === "") return;

        const maxValue = parseFloat(maxAttr);

        // If the input's value exceeds the max, set it to the max.
        if (parseFloat(input.value) > maxValue) {
          input.value = maxValue;
        }
      }

      /**
       * Main logic handler for the step button.
       * It either advances to the next step or resets the calculator.
       */
      _handleStepChange() {
        const totalSteps = this.elements.stepCards.length;

        // If we are on the last step, the button action is to reset
        if (this.currentStep === totalSteps) {
          this._reset();
        } else {
          // Otherwise, advance to the next step
          this.currentStep++;
          this._updateView();
        }
      }

      /**
       * Resets the calculator to the first step.
       */
      _reset() {
        this.currentStep = 1;
        this._updateView();
      }

      /**
       * Updates the DOM to reflect the current step.
       * This function handles card visibility and button state.
       */
      _updateView() {
        const totalSteps = this.elements.stepCards.length;
        const btn = this.elements.stepBtn;

        // Update visibility of the step cards
        this.elements.stepCards.forEach((card, index) => {
          // The index is 0-based, while currentStep is 1-based
          if (index + 1 === this.currentStep) {
            card.classList.add("current-step");
          } else {
            card.classList.remove("current-step");
          }
        });

        // Update the button's text and classes based on the new step
        btn.classList.remove(this.btnClasses.next, this.btnClasses.init);

        if (this.currentStep === totalSteps) {
          // We are now on the LAST step (the results)
          btn.innerHTML = `<span>${this.btnTexts.init}</span>`;
          btn.classList.add(this.btnClasses.init);
        } else if (this.currentStep === totalSteps - 1) {
          // We are now on the step BEFORE the results
          btn.innerHTML = `<span>${this.btnTexts.check}</span>`;
          btn.classList.add(this.btnClasses.next);
        } else {
          // We are on any other step
          btn.innerHTML = `<span>${this.btnTexts.next}</span>`;
          btn.classList.add(this.btnClasses.next);
        }
      }
    }

    customElements.define("speediance-calculator", SpeedianceCalculator);
  }
})();
